import QuizIcon from '@material-ui/icons/FormatListNumbered';
import GamesReportsList from './components/GamesReportsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Games',
  subMenuName: 'reports',
};

export default {
  list: GamesReportsList,
  icon: QuizIcon,
  name: 'admin/reports/games',
  options,
};
